import { Box, Tab, Tabs } from '@mui/material'
import Container from '@mui/material/Container'
import { CSSProperties, useState } from 'react'

import KanseiBreadcrumbs from 'components/breadcrumb'

import { InstructionSummaryTab } from './tabs/instructionSummaryTab'
import { ProperNounTab } from './tabs/properNounTab'

type TabPanelProps = {
  children?: React.ReactNode
  index: number
  value: number
}

function TabPanel({ children, value, index }: TabPanelProps) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  )
}

export default function ManualOperationPage() {
  const [tabIndex, setTabIndex] = useState(0)

  const links = [
    {
      title: '手動運用',
    },
  ]

  return (
    <Container maxWidth="lg">
      <KanseiBreadcrumbs links={links} style={breadcrumbStyle} />

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={tabIndex}
          onChange={(_, newValue) => setTabIndex(newValue)}
        >
          <Tab label="AIサマリ管理" />
          <Tab label="固有名詞マスタ" />
          {/* 将来の機能はここにタブを追加 */}
        </Tabs>
      </Box>

      <TabPanel value={tabIndex} index={0}>
        <InstructionSummaryTab />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <ProperNounTab />
      </TabPanel>
      {/* 将来の機能はここにTabPanelを追加 */}
    </Container>
  )
}

const breadcrumbStyle: CSSProperties = {
  marginBottom: '15px',
}
